import PolicyPage from "./PolicyPage";

export default function ShippingPolicy() {
  return <PolicyPage testid="page-shipping" policyKey="shipping" />;
}
